<template>
  <el-dialog
    width="500px"
    title="平台应用"
    :visible="visible"
    :close-on-click-modal="false"
    @close="close"
  >
    <span class="tips">注意：点击确认后需设置变体及价格，手动操作上传</span>
    <el-form label-width="120px" ref="form" :model="form" :rules="formRules">
      <el-form-item label="选择分类模板" prop="categoryStencil">
        <el-select
          v-model="form.categoryStencil"
          filterable
          value-key="channelType"
          style="width: 300px"
        >
          <el-option
            v-for="(item, index) in categoryStencilList"
            :key="index + 'category'"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择店铺模板" prop="sellerStencil">
        <el-select
          v-model="form.sellerStencil"
          filterable
          value-key="channelType"
          style="width: 300px"
        >
          <el-option
            v-for="(item, index) in sellerStencilList"
            :key="index + 'seller'"
            :label="item.stencilName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" :disabled="saveDisabled">取消</el-button>
      <el-button type="primary" @click="save" :disabled="saveDisabled"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";

export default {
  name: "plantFormUpload",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    categoryStencilList: {
      type: Array,
      default: () => [],
    },
    sellerStencilList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        categoryStencil: undefined, //重量
        sellerStencil: undefined, //运单号
      },
      formRules: {},
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("cancelVisible");
    },
    save() {
      let categoryStencilObj = this.categoryStencilList?.find(
        (ele) => ele.id === this.form.categoryStencil
      ); //分类模版
      const sellerStencilObj = this.sellerStencilList?.find(
        (ele) => ele.id === this.form.sellerStencil
      ); //店铺模版
      categoryStencilObj = JSON.parse(categoryStencilObj.value)
      this.$emit("save", { categoryStencilObj, sellerStencilObj });
    },
  },
};
</script>

<style scoped lang="scss">
.tips {
  color: #f56c6c;
  margin-left: 28px;
}
</style>
